import { useEffect } from "react";
import { useScene } from "./useScene";

export function useLayerCulling(items: readonly unknown[]) {
    const { nativeCullingManager } = useScene();

    // biome-ignore lint/correctness/useExhaustiveDependencies: Re-run culling whenever the layer items change.
    useEffect(() => {
        nativeCullingManager.requestCull();
    }, [items, nativeCullingManager]);
}
